import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withCtx as _withCtx, createElementBlock as _createElementBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps } from "vue"

const _hoisted_1 = { class: "gfu-box-actions" }
const _hoisted_2 = { class: "gfu-box-actions__item" }
const _hoisted_3 = ["href"]
const _hoisted_4 = { class: "gfu-box-actions__item" }
const _hoisted_5 = { "data-qa": "create-order-btn:Price" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "gfu-box-actions" }
const _hoisted_8 = { class: "gfu-box-actions__item _ml-a _pt-0" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_project_benefits_and_risks = _resolveComponent("project-benefits-and-risks")
  const _component_guest_checkout_fieldset = _resolveComponent("guest-checkout-fieldset")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_tooltip_button = _resolveComponent("tooltip-button")
  const _component_payment_info_box = _resolveComponent("payment-info-box")
  const _component_adyen_order_payment_options = _resolveComponent("adyen-order-payment-options")
  const _component_terms_of_service_checkbox_field = _resolveComponent("terms-of-service-checkbox-field")
  const _component_right_of_withdrawal_consent_checkbox_field = _resolveComponent("right-of-withdrawal-consent-checkbox-field")
  const _component_base_button = _resolveComponent("base-button")
  const _component_progress_overlay = _resolveComponent("progress-overlay")
  const _component_adyen_payment_context_provider = _resolveComponent("adyen-payment-context-provider")

  return (_openBlock(), _createBlock(_component_adyen_payment_context_provider, _normalizeProps(_guardReactiveProps($options.paymentConfiguration)), {
    default: _withCtx(() => [
      ($options.isOrderPayable)
        ? (_openBlock(), _createBlock(_component_adyen_order_payment_options, {
            key: 0,
            "project-id": _ctx.projectContext.projectID,
            "project-phase": _ctx.projectContext.project.phase,
            "project-type": _ctx.projectContext.project.type,
            "is-instant": $props.isInstant,
            "checkout-mode": $props.checkoutMode,
            "effective-payable-amount": $props.effectivePayableAmount,
            "order-code": $props.orderCode,
            "order-validation-id": $props.orderValidationID,
            "payment-type": $props.paymentType,
            reason: $props.reason,
            "order-id": $props.orderID,
            "is-in-test-mode": $props.isInTestMode,
            "is-guest": $setup.guestCheckout.isUnauthenticated,
            "user-email": $setup.guestCheckout.userEmail,
            "has-digital-items": $props.hasDigitalItems,
            onPaymentError: $setup.paymentAnalytics.trackPaymentError,
            onPaymentMethodChange: $setup.paymentAnalytics.trackPaymentMethodChange,
            onTogglePaymentGroupVisibilityChange: $setup.paymentAnalytics.trackPaymentGroupVisibilityToggle,
            "data-qa": "payment-section"
          }, {
            content: _withCtx(() => [
              _createVNode(_component_project_benefits_and_risks, {
                class: "_my-6",
                "is-stretch-pay-visible": false
              }),
              ($setup.guestCheckout.areFieldsVisible)
                ? (_openBlock(), _createBlock(_component_guest_checkout_fieldset, {
                    key: 0,
                    "model-value": $setup.guestCheckout.model,
                    "read-only": $setup.guestCheckout.areFieldsReadOnly
                  }, null, 8 /* PROPS */, ["model-value", "read-only"]))
                : _createCommentVNode("v-if", true)
            ]),
            actions: _withCtx(({ onSubmit, isProceedPaymentBlocked, paymentMethodErrorMessage, isProcessing, grantOrderAccess }) => [
              _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("a", {
                    href: $props.projectUrl,
                    class: "_tc--accent _flex _ai-c",
                    onClick: _cache[0] || (_cache[0] = (...args) => ($options.onGoBack && $options.onGoBack(...args)))
                  }, [
                    _createVNode(_component_base_icon, {
                      name: "chevron-left _mr-1",
                      "data-qa": "create-order-btn:Back"
                    }),
                    _createTextVNode(" " + _toDisplayString(_ctx.Resources.Common.GoBackButton), 1 /* TEXT */)
                  ], 8 /* PROPS */, _hoisted_3)
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_tooltip_button, {
                    "tooltip-text": paymentMethodErrorMessage,
                    enabled: !isProceedPaymentBlocked,
                    disabled: isProceedPaymentBlocked || isProcessing,
                    onClick: _withModifiers($event => ($options.handlePaymentSubmit(onSubmit, grantOrderAccess)), ["prevent"]),
                    "data-qa": "create-order-btn:Submit"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString($options.payableButtonLabel) + " ", 1 /* TEXT */),
                      _createElementVNode("span", _hoisted_5, _toDisplayString($options.amount), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["tooltip-text", "enabled", "disabled", "onClick"]),
                  _createVNode(_component_payment_info_box, { "payment-type": $props.paymentType }, null, 8 /* PROPS */, ["payment-type"])
                ])
              ])
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["project-id", "project-phase", "project-type", "is-instant", "checkout-mode", "effective-payable-amount", "order-code", "order-validation-id", "payment-type", "reason", "order-id", "is-in-test-mode", "is-guest", "user-email", "has-digital-items", "onPaymentError", "onPaymentMethodChange", "onTogglePaymentGroupVisibilityChange"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_terms_of_service_checkbox_field, {
              modelValue: _ctx.model.termsAccepted,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.model.termsAccepted) = $event)),
              name: "model.termsAccepted",
              "show-digital-content-info": $props.hasDigitalItems
            }, null, 8 /* PROPS */, ["modelValue", "show-digital-content-info"]),
            ($options.requireWithdrawalConsent)
              ? (_openBlock(), _createBlock(_component_right_of_withdrawal_consent_checkbox_field, {
                  key: 0,
                  modelValue: _ctx.model.isRightOfWithdrawalConsentAccepted,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => ((_ctx.model.isRightOfWithdrawalConsentAccepted) = $event)),
                  name: "model.isRightOfWithdrawalConsentAccepted"
                }, null, 8 /* PROPS */, ["modelValue"]))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_base_button, {
                  theme: "accent",
                  class: "gfu-btn--block",
                  onClick: $options.submitChangedOrder,
                  "data-qa": "create-order-btn:Submit"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString($options.nonPayableButtonLabel), 1 /* TEXT */)
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["onClick"])
              ]),
              _createVNode(_component_progress_overlay, { visible: _ctx.isProcessing }, null, 8 /* PROPS */, ["visible"])
            ])
          ]))
    ]),
    _: 1 /* STABLE */
  }, 16 /* FULL_PROPS */))
}